import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { computed, type MaybeRefOrGetter, unref } from 'vue';
import type { GetRegionSeoTagRequest } from '@/shared/api/experience';
import { useLoaderStore } from '@/shared/store/useLoaderStore';

export const useRegionTagSeoInfo = (tagId: MaybeRefOrGetter<string>, enabled: MaybeRefOrGetter<boolean>) => {
  const loaderStore = useLoaderStore();
  const { getSeoRegionTag } = useExperienceApi();

  const {
    data: regionTagSeoData,
    isSuccess,
    isFetching,
  } = useQuery({
    queryKey: ['regionTagSeoInfo', tagId],
    queryFn: async () => {
      const response = await getSeoRegionTag({ query: { ids: unref(tagId) as string } });

      loaderStore.check404(response);

      return response.data;
    },
    enabled: computed(() => !!unref(enabled)),
    placeholderData: (prevData): GetRegionSeoTagRequest => prevData || ({ faq: {}, seo: {} } as GetRegionSeoTagRequest),
    staleTime: 0,
    refetchOnMount: 'always',
  });

  return {
    regionTagSeoData,
    isSuccess,
    isFetching,
  };
};
